@let user = userStore.user();
@if (user) {    
    <div class="flex flex-col px-4 py-10">
        <span class="text-xl font-medium">User ID</span>
        <span class="py-1 text-lg">{{ user.userId }}</span>
        <span class="text-xl font-medium">Profile ID</span>
        <span class="py-1 text-lg">{{ user.profileId }}</span>
        <span class="text-xl font-medium">Email</span>
        <span class="py-1 text-lg">{{ user.email }}</span>
        <span class="text-xl font-medium">Earned</span>
        <span class="py-1 text-lg">{{ user.earned }}</span>
        <span class="text-xl font-medium">Withdrawn</span>
        <span class="py-1 text-lg">{{ user.withdrawn }}</span>
        <div class="w-full bg-gray-200 flex justify-between">
            <div class="flex flex-col">
                <span class="text-xl font-medium">Balance</span>
                <span class="py-1 text-lg">{{ user.earned - user.withdrawn }}</span>
            </div>
            <div class="flex items-center">
                <div [formGroup]="userBalanceForm">
                    <div class="flex pt-1">
                        <mat-form-field class="mx-1">
                            <mat-label>Reward</mat-label>
                            <input
                            type="number"
                                noScroll
                                matInput
                                formControlName="amount" />
                        </mat-form-field>
                        <mat-form-field class="mx-1">
                            <mat-label>EXP Reward</mat-label>
                            <input
                                type="number"
                                noScroll
                                matInput
                                formControlName="expAmount" />
                        </mat-form-field>                     
                    </div>              
                    <div class="w-full p-1">
                        <mat-form-field class="w-full">
                            <mat-label>Reason</mat-label>
                            <input
                                noScroll
                                matInput
                                formControlName="reason" />
                        </mat-form-field>
                    </div>                
            </div>
            <div class="flex items-center justify-center w-full h-full p-3">
                <button class="!text-2xl !h-[60px]" mat-flat-button color="primary" (click)="changeUserBalance()" [disabled]="userBalanceForm.invalid">Change balance</button>
            </div>
        </div>
    </div>
    <span class="text-xl font-medium">Installs</span>
    <span class="mb-5 pt-1 text-lg">{{ user.installs }}</span>
    <form [formGroup]="banUserForm" class="flex flex-col gap-3 w-full h-full p-3 bg-gray-200">
        <div class="flex gap-3">
            <button class="!text-2xl !h-[60px]" mat-flat-button color="warn" (click)="banUser()" [disabled]="user.isBanned">Ban User</button>
            <button class="!text-2xl !h-[60px]" mat-flat-button color="primary" (click)="unbanUser()" [disabled]="!user.isBanned">Unban User</button>
        </div>
        <mat-form-field>
            <mat-label>Reason</mat-label>
            <input
                matInput
                formControlName="reason" />
        </mat-form-field>
    </form>    
    <mat-tab-group>
        <mat-tab label="Conversions"><div class="mat-elevation-z3">
            <div class="flex items-center gap-x-4">
                    <span>FILTERS:</span>
                    <mat-form-field>
                        <mat-label>Goal Filter</mat-label>
                        <input matInput (keyup)="applyFilter($event)" #goalFilter>
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Reject Reason</mat-label>
                        <input matInput (keyup)="applyFilter($event)" #rejectReasonFilter>
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Forse Approve Reason</mat-label>
                        <input matInput (keyup)="applyFilter($event)" #forceApproveReasonFilter>
                      </mat-form-field>
                </div>
            <mat-table [dataSource]="conversionsDataSource" 
            matSort
            #conversionsSort="matSort"
            matSortActive="goal"
            matSortDirection="asc"
            matSortDisableClear>
                    <ng-container matColumnDef="goal">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Goal</mat-header-cell>
                        <mat-cell *matCellDef="let row">{{ row.goal }}</mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="offer">
                        <mat-header-cell *matHeaderCellDef  class="!bg-gray-100" mat-sort-header>Offer</mat-header-cell>
                        <mat-cell *matCellDef="let row" class="!bg-gray-100">{{ row.offer }}</mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="reward">
                        <mat-header-cell *matHeaderCellDef class="basis-[80px] grow-0" mat-sort-header>Reward</mat-header-cell>
                        <mat-cell *matCellDef="let row" class="basis-[80px] grow-0">${{ row.reward | number: "1.2-2" }}</mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="expReward">
                        <mat-header-cell *matHeaderCellDef class="basis-[80px] grow-0 !bg-gray-100" mat-sort-header>Exp reward</mat-header-cell>
                        <mat-cell *matCellDef="let row" class="basis-[80px] grow-0 !bg-gray-100">{{ row.expReward }}</mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="isApproved">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Approved</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <div class="flex flex-col">
                                <mat-checkbox
                                    [checked]="row.isApproved"
                                    disabled></mat-checkbox>
                                <p class="text-red-700">
                                    {{ row.rejectReason }}
                                </p>
                                <p class="text-green-700">
                                    {{ row.forceApproveReason }}
                                </p>
                            </div>
                        </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="isPaid">
                        <mat-header-cell *matHeaderCellDef class="basis-[80px] grow-0 !bg-gray-100" mat-sort-header>Paid</mat-header-cell>
                        <mat-cell *matCellDef="let row" class="basis-[80px] grow-0 !bg-gray-100">
                            <mat-checkbox
                                [checked]="row.isPaid"
                                disabled></mat-checkbox>
                        </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="isFraud">
                        <mat-header-cell *matHeaderCellDef class="basis-[80px] grow-0" mat-sort-header>Fraud</mat-header-cell>
                        <mat-cell *matCellDef="let row" class="basis-[80px] grow-0">
                            <div class="flex flex-col">
                                <mat-checkbox
                                    [checked]="row.isFraud"
                                    disabled></mat-checkbox>
                                <p class="text-red-700">
                                    {{ row.fraudReason }}
                                </p>
                            </div>
                        </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="conversionDate">
                        <mat-header-cell *matHeaderCellDef class="!bg-gray-100" mat-sort-header>Conversion date (UTC)</mat-header-cell>
                        <mat-cell *matCellDef="let row" class="!bg-gray-100">
                            {{ row.conversionDate | date: "dd.MM.yyyy HH:mm:ss" : "UTC" }}
                        </mat-cell>
                    </ng-container>
    
                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            @if (!row.isApproved) {
                                <div class="flex flex-col py-1 w-[140px]">
                                    <button
                                        mat-flat-button
                                        color="primary"
                                        (click)="reapproveConversion(row.conversionId)">
                                        Reapprove
                                    </button>
                                <div class="flex flex-col py-1 w-[140px]">
                                    <mat-form-field>
                                        <mat-label>Reason</mat-label>
                                        <textarea
                                            matInput
                                            #reasonInput
                                            cdkTextareaAutosize
                                            #autosize="cdkTextareaAutosize"
                                            cdkAutosizeMinRows="1"
                                            cdkAutosizeMaxRows="10"></textarea>
                                    </mat-form-field>
                                    <button
                                        mat-flat-button
                                        color="warn"
                                        (click)="
                                            forceApproveConversion(row.conversionId, reasonInput.value)
                                        ">
                                        Force approve
                                    </button>
                                </div>
                                </div>
                            }
                        </mat-cell>
                    </ng-container>
    
                    <mat-header-row
                        *matHeaderRowDef="[
                            'goal',
                            'offer',
                            'reward',
                            'expReward',
                            'isApproved',
                            'isPaid',
                            'isFraud',
                            'conversionDate',
                            'actions',
                        ]"></mat-header-row>
                    <mat-row
                        *matRowDef="
                            let row;
                            columns: [
                                'goal',
                                'offer',
                                'reward',
                                'expReward',
                                'isApproved',
                                'isPaid',
                                'isFraud',
                                'conversionDate',
                                'actions',
                            ]
                        "></mat-row>
                </mat-table>
                <mat-paginator
                    [pageSizeOptions]="[15, 30, 50]"
                    #conversionsPaginator
                    showFirstLastButtons
                    aria-label="Select page of periodic elements"></mat-paginator>
            </div></mat-tab>
            <mat-tab label="Transactions">
                <div class="mat-elevation-z3">
                    <mat-table [dataSource]="transactionsDataSource" 
                    matSort
                    #transactionsSort="matSort"
                    matSortActive="id"
                    matSortDirection="asc"
                    matSortDisableClear>
                        <ng-container matColumnDef="id">
                            <mat-header-cell *matHeaderCellDef class="basis-[120px] grow-0" mat-sort-header>ID</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="basis-[120px] grow-0">{{ row.id }}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="transactionType">
                            <mat-header-cell *matHeaderCellDef class="!bg-gray-100 basis-[240px] grow-0" mat-sort-header>Type</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="!bg-gray-100 basis-[240px] grow-0">{{ row.transactionType }}</mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="amount">
                            <mat-header-cell *matHeaderCellDef class="basis-[80px] grow-0" mat-sort-header>Amount</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="basis-[80px] grow-0" [ngClass]="{'text-red-600': row.amount < 0}">{{ row.amount | number: "1.2-2" }}$</mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="expAmount">
                            <mat-header-cell *matHeaderCellDef class="basis-[80px] grow-0 !bg-gray-100" mat-sort-header>Exp Amount</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="basis-[80px] grow-0 !bg-gray-100">{{ row.expAmount }}</mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <mat-header-cell *matHeaderCellDef class="basis-[240px] grow-0" mat-sort-header>Status</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="basis-[240px] grow-0">{{ row.status }}</mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="payload">
                            <mat-header-cell *matHeaderCellDef class="!bg-gray-100" mat-sort-header>Payload</mat-header-cell>
                            <mat-cell *matCellDef="let row" class="!bg-gray-100">{{ row.payload }}</mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="['id', 'transactionType', 'amount', 'expAmount', 'status', 'payload']"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: ['id', 'transactionType', 'amount', 'expAmount', 'status', 'payload']"></mat-row>
                    </mat-table>
                    <mat-paginator
                        [pageSizeOptions]="[15, 30, 50]"
                        #transactionsPaginator
                        showFirstLastButtons
                        aria-label="Select page of periodic elements">
                    </mat-paginator>
                </div>
            </mat-tab>
        </mat-tab-group>        
    </div>
}
